import React from "react";
import {RECTANGLE_TABLE_DATA} from "../../../enums/tableNumbers";
import ChipOnTable from "../../chip/chip-on-table";
import {toJS} from "mobx";

export const RectangleTableCenter = ({selectedData, allChipsTypes, handleGetColumnChip, ovalTableBetState, winNumber}) => {
  return (
    <div className="table-content-center">
      {RECTANGLE_TABLE_DATA.map(({number, color, self, left, right, center}) => {
        const selfChip = handleGetColumnChip(self);
        const leftChip = handleGetColumnChip(left);
        const rightChip = handleGetColumnChip(right);
        const centerChip = handleGetColumnChip(center);

        return (
          <div className={`main-game-cont-box ${winNumber === number ? 'win' : ''} ${color} ${(ovalTableBetState || selectedData)?.includes(number) ? 'active' : ''}`} key={number}
               data={self}>
            {number}
            <ChipOnTable
              type={self}
              columnChips={selfChip}
              allChipsTypes={allChipsTypes}
            />
            <div className="r-click center-left" data={left}>
              <ChipOnTable
                type={left}
                columnChips={leftChip}
                allChipsTypes={allChipsTypes}
              />
            </div>
            <div className="r-click bottom-right" data={right}>
              <ChipOnTable
                type={right}
                columnChips={rightChip}
                allChipsTypes={allChipsTypes}
              />
            </div>
            <div className="r-click bottom-center" data={center}>
              <ChipOnTable
                type={center}
                columnChips={centerChip}
                allChipsTypes={allChipsTypes}
              />
            </div>
          </div>
        )
      })}
    </div>
  );
};
